import React from "react";

interface Props {
  activeColor: string;
}
const ViewProfileIcon: React.FC<Props> = ({ activeColor = "#0f1560" }) => {
  return (
    <svg
      width="13"
      height="18"
      viewBox="0 0 13 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3182 11.6597H8.82791C8.55196 11.6597 8.32825 11.8834 8.32825 12.1593C8.32825 12.4353 8.55196 12.659 8.82791 12.659H10.3182C10.5941 12.659 10.8179 12.4353 10.8179 12.1593C10.8179 11.8834 10.5942 11.6597 10.3182 11.6597Z"
        fill={activeColor}
      />
      <path
        d="M10.3182 9.67432H2.72562C2.44967 9.67432 2.22595 9.89803 2.22595 10.174C2.22595 10.4499 2.44967 10.6736 2.72562 10.6736H10.3183C10.5942 10.6736 10.8179 10.4499 10.8179 10.174C10.8179 9.89803 10.5942 9.67432 10.3182 9.67432Z"
        fill={activeColor}
      />
      <path
        d="M2.72562 12.659H7.1936C7.46955 12.659 7.69327 12.4353 7.69327 12.1593C7.69327 11.8834 7.46955 11.6597 7.1936 11.6597H2.72562C2.44967 11.6597 2.22595 11.8834 2.22595 12.1593C2.22595 12.4353 2.44967 12.659 2.72562 12.659Z"
        fill={activeColor}
      />
      <path
        d="M10.3182 13.645H2.72562C2.44967 13.645 2.22595 13.8687 2.22595 14.1447C2.22595 14.4206 2.44967 14.6444 2.72562 14.6444H10.3183C10.5942 14.6444 10.8179 14.4206 10.8179 14.1447C10.8179 13.8687 10.5942 13.645 10.3182 13.645Z"
        fill={activeColor}
      />
      <path
        d="M10.0802 5.98322C10.39 5.65711 10.5807 5.21687 10.5807 4.73263C10.5807 3.73039 9.76532 2.91504 8.76313 2.91504C7.76093 2.91504 6.94557 3.73043 6.94557 4.73263C6.94557 5.21687 7.13631 5.65711 7.4461 5.98322C6.89404 6.38919 6.53491 7.04288 6.53491 7.77913V8.17526C6.53491 8.45121 6.75863 8.67493 7.03458 8.67493H10.4917C10.7677 8.67493 10.9914 8.45121 10.9914 8.17526V7.77913C10.9914 7.04288 10.6322 6.38919 10.0802 5.98322ZM7.94487 4.73263C7.94487 4.28143 8.31196 3.91437 8.76309 3.91437C9.21429 3.91437 9.58135 4.28146 9.58135 4.73263C9.58135 5.18379 9.21426 5.55085 8.76309 5.55085C8.31196 5.55085 7.94487 5.18379 7.94487 4.73263ZM7.53854 7.67556C7.59127 7.04618 8.12036 6.55018 8.76313 6.55018H8.76316C9.40593 6.55018 9.93501 7.04622 9.98774 7.67556H7.53854Z"
        fill={activeColor}
      />
      <path
        d="M12.4903 0.251953H3.86505C3.73251 0.251953 3.60543 0.304618 3.51172 0.398322L0.146336 3.76408C0.0526316 3.85778 0 3.9849 0 4.11737V16.8076C0 17.0835 0.223717 17.3072 0.499666 17.3072H12.4903C12.7663 17.3072 12.99 17.0835 12.99 16.8076V0.75162C12.99 0.475671 12.7663 0.251953 12.4903 0.251953ZM3.36535 1.95805V3.61734H1.70626L3.36535 1.95805ZM11.9907 16.3079H0.999333V4.61664H3.86505C4.141 4.61664 4.36472 4.39292 4.36472 4.11697V1.25129H11.9907V16.3079Z"
        fill={activeColor}
      />
    </svg>
  );
};

export default ViewProfileIcon;
